import { Component, Vue } from 'vue-property-decorator';

import MenuItemInterface from '@/model/vo/navigation/menu-item-interface';

@Component
export default class NavbarComponent extends Vue
{
    /**
     * Returns the visibility of the navbar
     */

    private get visible(): boolean
    {
        return this.$store.getters['ui/navbarVisible'];
    }

    /**
       * Sets the visibility of the navbar
       */

    private set visible(navbarVisible: boolean)
    {
        this.$store.commit('ui/navbarVisible', navbarVisible);
    }

    /**
     * Returns the base items for the navbar
     */

    private get items(): MenuItemInterface[]
    {
        const items: MenuItemInterface[] = [];

        // General items
        items.push(...[
            {
                title: this.$t('navbar.message.clients').toString(),
                route: {
                    name: 'client-index',
                },
                icon: 'mdi-account-group',
                active: true,
            },
            {
                title: this.$t('navbar.message.techspecs').toString(),
                route: {
                    name: 'techspec-index',
                },
                icon: 'mdi-text-box',
                active: true,
            },
            {
                title: this.$t('navbar.message.jobs').toString(),
                route: {
                    name: 'job-index',
                },
                icon: 'mdi-briefcase',
                active: true,
            },
            {
                title: this.$t('navbar.message.meetings').toString(),
                route: {
                    name: 'meeting-index',
                },
                icon: 'mdi-handshake',
                active: true,
            },
            {
                title: this.$t('navbar.message.services').toString(),
                route: {
                    name: 'service-index',
                },
                icon: 'mdi-room-service',
                active: true,
            },
            {
                title: this.$t('navbar.message.domains').toString(),
                route: {
                    name: 'domain-index',
                },
                icon: 'mdi-domain',
                active: true,
            },
            {
                title: this.$t('navbar.message.invoices').toString(),
                route: {
                    name: 'invoice-index',
                },
                icon: 'mdi-receipt-text',
                active: true,
            },
            {
                title: this.$t('navbar.message.calendar').toString(),
                route: {
                    name: 'calendar',
                },
                icon: 'mdi-calendar',
                active: true,
            },
            {
                title: this.$t('navbar.message.timesheets').toString(),
                route: {
                    name: 'timesheets',
                },
                icon: 'mdi-timer',
                active: true,
            },
        ]);

        return items;
    }

    /**
     * Returns user specific menu items taking into account role access.
     */

    get userItems(): MenuItemInterface[]
    {
        if (!this.$user)
        {
            return [];
        }

        const items: MenuItemInterface[] = [];

        for (const item of this.items)
        {
            if (!this.userCanSeeItem(item))
            {
                continue;
            }

            const clone = Object.assign({}, item);

            if (item.children)
            {
                clone.children = [];

                for (const childItem of item.children)
                {
                    if (!this.userCanSeeItem(childItem))
                    {
                        continue;
                    }

                    clone.children.push(childItem);
                }
            }

            items.push(clone);
        }

        return items;
    }

    /**
     * Returns whether the user can see the given item.
     *
     * @param item
     */

    private userCanSeeItem(item: MenuItemInterface): boolean
    {
        return true;
    }
}